// extracted by mini-css-extract-plugin
export default {"loading_error":"LoadingError_loading_error__Y1sAh"};